<div class="category-manager">
  <div class="table-operations">
    <button nz-button nzType="primary" (click)='openAdd()'>新增分类</button>
  </div>

  <nz-table
    #basicTable
    [nzData]="displayCategories"
    [nzLoading]="loading"
    nzTableLayout="fixed"
    [nzFrontPagination]="true"
    [nzPageSize]="10"
  >
    <thead>
      <tr>
        <th>分类名称</th>
        <th>描述</th>
        <th nzWidth="100px">排序</th>
        <th nzWidth="150px">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>{{ data.name }}</td>
        <td>{{ data.description }}</td>
        <td>{{ data.seq }}</td>
        <td>
          <a (click)="openEdit(data)">编辑</a>
          <nz-divider nzType="vertical"></nz-divider>
          <a class="delete-btn" (click)="deleteCategory(data.id)">删除</a>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <nz-modal
    [(nzVisible)]="modalVisible"
    [nzTitle]="modalTitle"
    [nzOkLoading]="okLoading"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()"
  >
    <ng-container *nzModalContent>
      <form nz-form>
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>分类名称</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <input nz-input [(ngModel)]="form.name" name="name" placeholder="请输入分类名称" />
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24">排序</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <nz-input-number [(ngModel)]="form.seq" name="seq" [nzMin]="0"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24">描述</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <textarea nz-input [(ngModel)]="form.description" name="description" placeholder="分类描述"></textarea>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>
</div>

